import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class BiddingPlatformItemApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'bidding-platform-item'
    }


 

}